import {validatePixel} from '../../../privates/validations/styleValidation';
import styleService from './styleService';
import * as members from '../../../privates/privateMembers';
import StyleProperties from '../../../privates/styleConstants';

class BorderRadiusMixin {

  /**
   * @member borderRadius
   * @memberof $w.Style
   * @param {external:String} borderRadius
   */
    set borderRadius(borderRadius) {
        const compName = members._compName.get(this);

        const isValidBorderRadius = validatePixel(borderRadius, StyleProperties.BORDER_RADIUS, compName, 'radius');
        if (!isValidBorderRadius){
            return;
        }
        styleService.setStyle.call(this, StyleProperties.BORDER_RADIUS, borderRadius);
    }

    /**
     * @member borderRadius
     * @label property
     * @syntax
     * get borderRadius(): string
     * set borderRadius(radius: string): void
     * @summary Sets or gets the border radius of an element.
     * @description
     *  The [border radius](https://www.w3schools.com/cssref/css3_pr_border-radius.asp)
     *  value is a string representing the element's border radius in pixels.
     *  For example, `"1px"`.
     * 
     * This style can be used with the following elements: 
     * 
     *  + [`Button`]($w.Button.html)
     *  + [`Checkbox`]($w.Checkbox.html)
     *  + [`Dropdown`]($w.Dropdown.html)
     *  + [`TextBox`]($w.TextBox.html)
     *  + [`TextInput`]($w.TextInput.html) 
     *  + [`UploadButton`]($w.UploadButton.html)     
     *  
     * @snippet [BorderRadiusMixin-borderRadius_set.es6=Set the border radius]
     * @snippet [BorderRadiusMixin-borderRadius_get.es6=Get the border radius]
     * @type {external:String}
     * @memberof $w.Style
     * @instance
     */
    get borderRadius() {
        return styleService.getStyleParamValue.call(this, StyleProperties.BORDER_RADIUS);
    }


}

export default BorderRadiusMixin;
